export default __webpack_public_path__ + "static-front/media/AlertIcon.72697c7e.svg";